import React from 'react';
import LoadingModal from '../common/loadingModal';
import Message from '../common/message';
import FormComponentWrapper from './form_components/formComponentWrapper';
import Title from './form_components/title';
import Constants from '../../containers/function/constants.js';

const TaskModal = (props) => {
  const classNameHide = props.showModal ? '' : 'hide';
  const classNameContainerModal = props.showFullscreen ? 'container-modal-fullscreen' : 'container-modal-right';

  let container = '';
  if (
    props.activeTask.loading ||
    props.saveTask.loading
  ) {
    container = <LoadingModal language={props.language} height="modal-task" />;
  } else if (
    props.activeTask.status == 200 &&
    props.activeTask.datos != null &&
    props.showModal &&
    (props.saveTask.status == null || props.saveTask.status == 422 || props.showFullscreen)
  ) {
    container = (
      <div className="container-detail-modal-right">
        <form onSubmit={(e) => e.preventDefault()} className="task-form-data-form">
          <div className="task-content-modal-right">
            <Title label={props.activeTask.datos.title}/>
            <div className="task-generated-content">
              {
                props.activeTask.datos.state && (
                  <h4>
                    <span className="mb-4">
                      <div className="task-state">
                        <label>{props.language.tasks_manager.table.state}</label>
                        <div
                          style={{
                            color: Constants.taskManagerStateColorRange[props.activeTask.datos.state.key.toUpperCase()]
                          }}>
                          {props.activeTask.datos.state.label}
                          {
                            props.activeTask.datos.state.timeElapsed && (
                              <div className="state_time_elapsed">
                                <div className="state-clock"/>{props.activeTask.datos.state.timeElapsed}
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </span>
                  </h4>
                )
              }

              {
                props.activeTask.datos.fields && props.activeTask.datos.fields.map((item, i) => {
                  return (
                    <FormComponentWrapper
                      formProperty={item}
                      key={i}
                      handleModalHtmlPopup={props.handleModalHtmlPopup}
                      saveData={props.saveTask.datos[item.key]}
                      handleOnChange={props.handleOnChange}
                      getOptionsEndpoint={props.getOptionsEndpoint}
                      getTaskFile={props.getTaskFile}
                      errors={
                        props.saveTask.message
                        && props.saveTask.message.error 
                        && props.saveTask.message.error.params
                        && props.saveTask.status == 422
                        ? props.saveTask.message.error.params : null
                      }
                      language={props.language}
                    />
                  );
                })
              }
            </div>
            <div className="form-input top center">
              {props.activeTask.datos.possibleActions &&
              props.activeTask.datos.possibleActions.map(function(item, i) {
                return (<input
                  key={i}
                  type="button"
                  value={props.language.tasks_manager.taskform.actions[item]}
                  className={"action-button action-button-" + item}
                  data-action={item}
                  onClick={() => props.handleTaskAction(item)}
                />);
              })}
            </div>
          </div>
        </form>
      </div>
    );
  } else if (
    (props.saveTask.status != 200 && props.saveTask.status != 422 && props.saveTask.status != null) || 
    (props.activeTask.status != 200 && props.activeTask.status != null)
  ) {
    container = (
      <div className="container-detail-modal-right message">
        <Message message={'API ERROR'} />
      </div>
    );
  } else if (props.saveTask.status == 200) {
    container = (
      <div className="container-detail-modal-right message">
        <Message
          success={true}
          message={props.language.tasks_manager.taskform.actionsResults[props.saveTask.action].toUpperCase()}
        />
      </div>
    );
  } else {
    container = <div className="container-detail-modal-right" />;
  }

  return (
    <div className={`task-modal container-detail ${classNameContainerModal} ${classNameHide}`}>
      <div className="box-modal" id="modal-task">
        {
          (!props.showFullscreen) && (
            <a
              className={'close' + ((props.activeTask.status != 200 || props.saveTask.status == 200) ? ' message' : '')}
              onClick={props.handleModal}
            >
              <i className="fas fa-times-circle" />
            </a>
          )
        }

        { container }
      </div>
    </div>
  )
};

export default TaskModal;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/taskModal.jsx